"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _SliderComponent = _interopRequireDefault(require("./components/SliderComponent"));

var _BenefitsComponent = _interopRequireDefault(require("./components/BenefitsComponent"));

var _DetailsDescriptionComponent = _interopRequireDefault(require("./components/productDescription/DetailsDescriptionComponent"));

var _DetailsTabComponent = _interopRequireDefault(require("./components/TabsSection/DetailsTabComponent"));

var _LifeStyleImagesComponent = _interopRequireDefault(require("./components/LifeStyleImagesComponent"));

var _creators = require("../../../redux/creators");

var _utils = require("./../../../configuration/utils");

var _constans = require("./../../../configuration/constans");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProductDetailComponent = function ProductDetailComponent(_ref) {
  var productDetails = _ref.productDetails,
      setRelatedProducts = _ref.setRelatedProducts,
      filtersParams = _ref.filtersParams,
      resetFetchInitialization = _ref.resetFetchInitialization;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      devices = _useState2[0],
      setDevices = _useState2[1];

  var pimProduct = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var accessoryParametr = (0, _reactRedux.useSelector)(function (state) {
    return state.accessoryParametr;
  });
  var productList = (0, _reactRedux.useSelector)(function (state) {
    return state.productList;
  });
  var urlParams = new URLSearchParams(window.location.href);

  var fetchProductCard = function fetchProductCard() {
    setLoader();
    (0, _utils.getProductDetailsWithSettings)(dictionary.settingsParam.params, dictionary.settingsParam.token).then(function (pimData) {
      if (!pimData || !pimData.products) {
        resetFetchInitialization();
        stopLoader();
      } else {
        var _pimData$products$;

        dispatch((0, _creators.setActiveProduct)((pimData === null || pimData === void 0 ? void 0 : pimData.products[0]) || {}));
        stopLoader(); // getGuideDevices(dictionary.settingsParam.params).then((results) => {
        //   setDevices(results);
        // });

        if (((_pimData$products$ = pimData.products[0]) === null || _pimData$products$ === void 0 ? void 0 : _pimData$products$.productType) === 'Hearing Instrument') {
          (0, _utils.getRelatedAccessoriesWithSettings)(dictionary.settingsParam.params, dictionary.settingsParam.token).then(function (relatedAccessories) {
            var dataWithRelatedAccessories = pimData.products[0];
            dataWithRelatedAccessories.relatedAccessories = relatedAccessories.relatedAccessories;
            dispatch((0, _creators.setRelatedAccessories)(dataWithRelatedAccessories));
            setRelatedProducts(true);
          });
        }
      }
    })["catch"](function (err) {
      console.error(err);
      resetFetchInitialization();
    });
  };

  var setLoader = function setLoader() {
    window.scrollTo(0, 0);

    if (productList) {
      var _document$querySelect;

      (0, _utils.pepSkeletonLoader)("end");
      (_document$querySelect = document.querySelector(".".concat(_constans.initialState.pepListComponentName))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add("skeleton-fake-details-page");
    }
  };

  var stopLoader = function stopLoader() {
    (0, _utils.pepSkeletonLoader)("end");

    if (productList) {
      setTimeout(function () {
        var _document$querySelect2;

        (_document$querySelect2 = document.querySelector(".".concat(_constans.initialState.pepListComponentName))) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.remove("skeleton-fake-details-page");
      }, 600);
    }
  };

  (0, _react.useEffect)(function () {
    fetchProductCard();
    return function () {
      setRelatedProducts(false);
      setDevices(null);
    };
  }, [productDetails]);

  var backButton = function backButton() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "back-arrow"
    }, "<"), urlParams.has(accessoryParametr.replace("&", "")) ? dictionary.backToAccessoriesList : dictionary.backToHearingAids);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, pimProduct && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-top-section bg-grey-section"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid-container"
  }, !urlParams.has("redirectUrl") ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (urlParams.has(accessoryParametr.replace("&", "")) ? dictionary.accessoriesListPath : dictionary.instrumentListPath) + filtersParams,
    className: "back-button",
    tabIndex: 5
  }, backButton()) : /*#__PURE__*/_react["default"].createElement("a", {
    href: urlParams.get("redirectUrl"),
    className: "back-button",
    tabIndex: 5
  }, backButton())), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-top-container grid-container flex-row"
  }, /*#__PURE__*/_react["default"].createElement(_SliderComponent["default"], null), /*#__PURE__*/_react["default"].createElement(_DetailsDescriptionComponent["default"], null))), pimProduct.benefits.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefits-section flex-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid-container"
  }, /*#__PURE__*/_react["default"].createElement(_BenefitsComponent["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "details-tab-section flex-row bg-brown-grey-section"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid-container"
  }, /*#__PURE__*/_react["default"].createElement(_DetailsTabComponent["default"], {
    devices: devices
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lifestyle-images-section flex-row"
  }, /*#__PURE__*/_react["default"].createElement(_LifeStyleImagesComponent["default"], null))));
};

var _default = ProductDetailComponent;
exports["default"] = _default;